module.exports = __webpack_public_path__ + "static/media/service_online_6.d55056ab.png";